import React from 'react';
import { ChildSupportTextMax } from './ChildSupportText/ChildSupportTextMax';
import { ChildSupportTextMid } from './ChildSupportText/ChildSupportTextMid';
import { ChildSupportTextMin } from './ChildSupportText/ChildSupportTextMin';

export const ChildSupportContent = ({ packageName }) => {
  if (packageName === 'min') {
    return (
      <div className="child-support-info-content">
        <ChildSupportTextMin />
      </div>
    );
  }

  if (packageName === 'mid') {
    return (
      <div className="child-support-info-content">
        <ChildSupportTextMid />
      </div>
    );
  }

  return (
    <div className="child-support-info-content">
      <ChildSupportTextMax />
    </div>
  );
};
